function upsertById(items, row) {
  if (!row?.id) return items;
  const exists = items.some((item) => String(item.id) === String(row.id));
  return exists
    ? items.map((item) =>
        String(item.id) === String(row.id) ? { ...item, ...row } : item
      )
    : [...items, row];
}

// Kuyruk, IndexedDB önbelleğinden sonra uygulanır; böylece tarayıcı kapanıp açılsa da
// henüz sunucuya gitmemiş saha değişiklikleri ekranda kaybolmuş gibi görünmez.
export function applyQueueToWorkspace(cachedWorkspace, queue = []) {
  const workspace = {
    paftaList: [...(cachedWorkspace?.paftaList || [])],
    pointList: [...(cachedWorkspace?.pointList || [])],
    teamList: [...(cachedWorkspace?.teamList || [])],
    timestamp: cachedWorkspace?.timestamp || null,
  };

  queue.forEach((task) => {
    switch (task?.type) {
      case "createPoint":
        workspace.pointList = upsertById(workspace.pointList, task.data);
        break;
      case "updatePoint":
        workspace.pointList = workspace.pointList.map((point) =>
          String(point.id) === String(task.pointId)
            ? { ...point, ...(task.updates || {}) }
            : point
        );
        break;
      case "createTeam":
        workspace.teamList = upsertById(workspace.teamList, task.data);
        break;
      case "updateTeam":
        workspace.teamList = workspace.teamList.map((team) =>
          String(team.id) === String(task.teamId)
            ? { ...team, ...(task.data || {}) }
            : team
        );
        break;
      case "deleteTeam":
        workspace.teamList = workspace.teamList.filter(
          (team) => String(team.id) !== String(task.teamId)
        );
        workspace.pointList = workspace.pointList.map((point) =>
          String(point.ekipId) === String(task.teamId)
            ? { ...point, ekipId: null }
            : point
        );
        break;
      case "updatePafta":
        workspace.paftaList = workspace.paftaList.map((pafta) =>
          String(pafta.id) === String(task.paftaId)
            ? { ...pafta, ...(task.updates || {}) }
            : pafta
        );
        break;
      case "deletePafta":
        workspace.paftaList = workspace.paftaList.filter(
          (pafta) => String(pafta.id) !== String(task.paftaId)
        );
        workspace.pointList = workspace.pointList.filter(
          (point) => String(point.paftaId) !== String(task.paftaId)
        );
        workspace.teamList = workspace.teamList.filter(
          (team) => String(team.paftaId) !== String(task.paftaId)
        );
        break;
      default:
        break;
    }
  });

  return workspace;
}
